import React from 'react';
import { Lot } from '../../../../../../../types/lot';
import CreateLotModal from '../../../../../Stock/Lot/CreateLotModal';

interface CreateOrderCreateLotModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onCreated: (lot: Lot) => void;
  pmdId: string;
}

export default function CreateOrderCreateLotModal({ open, setOpen, onCreated, pmdId }: CreateOrderCreateLotModalProps) {
  return <CreateLotModal open={open} setOpen={setOpen} onCreated={onCreated} pmdId={pmdId} />;
}
